import { sendRequest } from './index';
import { API_CORE_URL } from '@core/constants/API';

export const ExploreData = {
	GET: (feture_content) =>
		sendRequest({
			url: `${API_CORE_URL}explore-data${feture_content ? '?featured_contents=true' : ''}`,
			method: 'GET'
		})
};

export const Explore = {
	GET: (queryParams) => {
		return sendRequest({
			url: `${API_CORE_URL}explore${queryParams}`,
			method: 'GET'
		});
	}
};
